import { render, staticRenderFns } from "./FolderEditDialog.vue?vue&type=template&id=72400394&"
import script from "./FolderEditDialog.vue?vue&type=script&lang=ts&"
export * from "./FolderEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports